import React, { Component } from 'react';
import AbacusSelect from '../Components/AbacusSelect';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle'
import AbacusTextField from '../Components/AbacusTextField';
import Util from './../Util/Util';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';
import { TableHead, TableRow, TableCell, TableBody, Table, CircularProgress } from '@material-ui/core';

/// Tools Class. 
class Tools extends Component {
    // Variables 
    token;
    data;
    currentState = {
        applicationType: "14ac405f-1b0c-46a4-b10f-01d4071ca13c"
    };
    applicationTypes = [
        { value: "a5d17698-48fe-4f0a-84fa-19857406a1ae", text: "Abacus Law" },
        { value: "418e1b76-3f46-4e01-8720-dcaf1ece8115", text: "Amicus Attorney" },
        { value: "14ac405f-1b0c-46a4-b10f-01d4071ca13c", text: "Amicus Cloud" },
        { value: "f04c4d2b-57ad-409b-9f60-703d00187a4e", text: "Office Tools" },
        { value: "c5dd2f9d-3810-46c4-830b-dafb5d7fccf9", text: "Office Tools Cloud"},
    ];

    // Constructor initiate callback methods and sets initial state
    constructor(props) {
        super(props);

        this.data = props.data;
        this.state = {
            applicationType: "14ac405f-1b0c-46a4-b10f-01d4071ca13c",
            open: false,
            customerNumber: "",
            error: false,
            tableData: [],
            showProgress: false
        }

        this.handleClickOpen = this.handleClickOpen.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    // Drop Down Change Events
    dropDownChange(controlName, event) {
        if (controlName === "ApplicationType") {
            this.setState({ applicationType: event.target.value });
        }

    }

    // Text Field Change Events
    textFieldChange(control, event) {
        this.currentState.IsValid = false;
        if (control === "CustomerID") {
            this.setState({ customerNumber: event.target.value });
        }
        this.validateEmpty();
    }



    validateEmpty() {
        let util = new Util();
        if (util.trim(this.state.customerNumber) === "") {
            this.currentState.IsValid = false;
        }
    }

    clearState() {
        this.currentState = {
            customerNumber: "",
            applicationType: "14ac405f-1b0c-46a4-b10f-01d4071ca13c",
            IsValid: false,
        }
    }
    /// Adjust controls and set states. State can be set only 
    /// once so group all events changes.
    setControlsState() {
        // Final set state
        this.setState({ ...this.currentState });
    }

    sendCallback() {
        this.clear();
        //this.data.Service.GetAccountManagementHistoryList(this.token, 1);
    }

    clear() {
        this.currentState = {
            customerNumber: "",
            applicationType: "14ac405f-1b0c-46a4-b10f-01d4071ca13c",
            open: false,
            tableData: []
        }

        this.setControlsState();
    }

    buttonStyle = {
        width: "130px",
        marginTop: "12px"
    }

    onBlur() {
        this.getAPXTokenForCustomer();
    }

    getAPXTokenForCustomer() {
        let util = new Util();
        if (util.trim(this.state.customerNumber).length === 0) {
            return;
        };
        this.setState({ error: false, errorMsg: '', showProgress: true });
        let request = {
            CustomerIdentifier: this.state.customerNumber,
            ApplicationIdentifier: this.state.applicationType
        }

        this.props.data.Service.GetAPXTokenForCustomer(request, this.getList.bind(this));
    }

    getList(token) {
        this.token = token;
        this.data.Service.GetAccountDetails(token, this.getAccount.bind(this));
    }

    getAccount(res) {
        console.log(res);
        if (typeof res === 'string' || res instanceof String) {
            console.log("It's a string");
            this.setState({ error: true, errorMsg: res, tableData: [], showProgress: false });
        }
        else {
            this.setState({ tableData: res.accounts, showProgress: false });
            console.log(this.state.tableData);
        }
    }


    handleClickOpen() {
        this.setState({ open: true });
    }

    handleClose() {
        this.setState({
            open: false, tableData: [],
            customerNumber: "",
            applicationType: "14ac405f-1b0c-46a4-b10f-01d4071ca13c",
            error: false, 
            errorMsg: ''
        });
    }
    PaperComponent(props) {
        return (
            <Draggable cancel={'[class*="MuiDialogContent-root"]'}>
                <Paper {...props} />
            </Draggable>
        );
    }

    /// Render html
    render() {
        return (
            <div style={{ marginTop: "5px" }}>
                <Button variant="outlined" color="primary" onClick={this.handleClickOpen}>
                    Tools
                </Button>
                <Dialog open={this.state.open} onClose={this.handleClose} aria-labelledby="form-dialog-title"
                    PaperComponent={this.PaperComponent}>
                    <DialogTitle style={{ cursor: 'move', textAlign: "center" }} id="form-dialog-title">Account Details</DialogTitle>
                    <DialogContent>
                        <AbacusSelect error={false} style={{ width: "250px", margin: "5px" }} value={this.state.applicationType}
                            list={this.applicationTypes} label="Application"
                            onChange={this.dropDownChange.bind(this, "ApplicationType")}></AbacusSelect>

                        <AbacusTextField onBlur={this.onBlur.bind(this)} value={this.state.customerNumber}
                            style={{ width: "250px", margin: "5px" }} Name="Customer ID" helperText="" error={this.state.error} errorText={this.state.errorMsg}
                            onChange={this.textFieldChange.bind(this, "CustomerID")}></AbacusTextField>
                        {this.state.showProgress ? <CircularProgress style={{ marginTop: "0px", position: "absolute", left: "50%", top: "50%" }} /> : null}
                        {this.state.tableData.length === 0 ? null :
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell></TableCell>
                                        <TableCell>Merchant Profile ID</TableCell>
                                        <TableCell>Merchant Account No.</TableCell>
                                        <TableCell>Account ID</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.tableData.map(row => (
                                        <TableRow >
                                            <TableCell>
                                                {row.bankingAccountTypeIdentifier === "bed5ee9e-f56f-45b0-a451-d6a109dd9d83" ? "Operating Account" : "Trust Account"}
                                            </TableCell>
                                            <TableCell align="right">{row.merchantProfileId}</TableCell>
                                            <TableCell align="right">{row.merchantAccountNumber}</TableCell>
                                            <TableCell align="right">  {row.accountId}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="primary">
                            Cancel
                        </Button>
                    </DialogActions>

                </Dialog>
            </div>
        );
    }
}

export default Tools;